module.exports = __webpack_public_path__ + "static/media/69.66ef50c3.jpg";